import { Component, OnInit, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { LocaleService } from '../../services/locale.service';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './app-footer.component.html',
  host: {
    class: 'z-0'
  }
})
export class AppFooterComponent implements OnInit {
  private readonly localeService = inject(LocaleService);
  protected readonly cookieConsentService = inject(CookieConsentService);

  protected readonly copyRightYear = new Date().getFullYear();
  protected readonly version = environment.version;
  protected privacyPolicyURL = '';
  protected termsAndConditionsURL = '';
  protected preferredLanguage = '';

  ngOnInit(): void {
    this.preferredLanguage = this.localeService.resolvePreferredLocale();

    if (this.preferredLanguage === 'en-ca') {
      this.privacyPolicyURL = environment.quickLinks.privacyPolicyEn;
      this.termsAndConditionsURL = environment.quickLinks.termsAndConditionsEn;
    }

    if (this.preferredLanguage === 'fr-ca') {
      this.privacyPolicyURL = environment.quickLinks.privacyPolicyFr;
      this.termsAndConditionsURL = environment.quickLinks.termsAndConditionsFr;
    }

    if (!this.privacyPolicyURL || !this.termsAndConditionsURL) {
      this.privacyPolicyURL = environment.quickLinks.privacyPolicyEn;
      this.termsAndConditionsURL = environment.quickLinks.termsAndConditionsEn;
    }
  }

  protected openCookieSettings(): void {
    this.cookieConsentService.openPreferenceCenter();
  }
}
